module.exports = __webpack_public_path__ + "img/usa-flag.e6fd4549.png";